<button mat-raised-button color="accent" [disabled]="isDisabled" (click)="selectItemsToExport()">
  Export conversation...
  <mat-icon class="icon">output</mat-icon>
</button>
